import {
  IListState,
  TBrandsAPI
} from '../../shared_components/vrr_dropdown/types';

export const prepareBrands = (brands?: TBrandsAPI[]): IListState[] | [] => {
  if (!brands) return [];
  const newBrands: IListState[] = [];
  brands.forEach((brand) => {
    if (brand.status !== 'hidden') {
      const { ad_accounts, brand_id, brand_name } = brand;
      newBrands.push({
        ad_accounts,
        label: brand_name,
        value: brand_id.toString()
      } as IListState);
    }
  });

  return newBrands;
};

export const getCurrentBrand = (
  currentBrandId?: string,
  brands?: IListState[] | []
): string | undefined => {
  if (!brands) return undefined;
  if (currentBrandId === '0') return brands[0]?.value;
  return brands.find((brand) => brand.value === currentBrandId)?.value;
};
